import {
  assignValueFromGanttToLookaheadRefHelperHack,
  findDeepGetTask
} from '../../GanttVisualization.helper';
import { getIsOdd } from '../common/validators';
import {
  calculateAndUpdateTaskValues,
  calculateExpectedCost,
  currencySymbolByProject,
  formatValue,
  isTaskDisabledForNumeric,
  shouldSkipRendering
} from './utils';

const renderNumeric = ({ task, column, t, projectState }) => {
  const gantt = window.ganttVisualization;
  const columnName = column?.name;

  if (columnName === 'expected_cost') {
    const result = calculateExpectedCost(
      task,
      assignValueFromGanttToLookaheadRefHelperHack
    );
    if (result) {
      task[columnName] = result;
    }
  }

  if (shouldSkipRendering(task, columnName)) return '';

  const currencySymbol = ['expected_cost', 'cost'].includes(columnName)
    ? currencySymbolByProject(projectState.projectSelected)
    : '';

  const taskFromLookahead = findDeepGetTask(window.activities, 'id', task?.id);
  calculateAndUpdateTaskValues(task, taskFromLookahead, columnName);

  isTaskDisabledForNumeric(task, columnName, column);

  const isOdd = getIsOdd({ gantt, task }, columnName);

  const valueNumber = task[columnName]
    ? formatValue(parseFloat(task[columnName]), column, t)
    : 0;

  return ` <div>
            <div class="${isOdd ? 'odd-col' : 'non-odd-col'}">
                <span class="${`vertical-center ${task.type === 'main' ? 'is-activity' : ''}`}">
                    ${String(currencySymbol) + valueNumber}
                </span>
            </div>
        </div>`;
};

export default renderNumeric;
